import React from 'react';
import { Tabs as MuiTabs } from '@mui/material';

/**
 * Universal Tabs component for the UI kit.
 * Compatible with the MUI Tabs API.
 *
 * Example usage:
 *
 * import Tab from '@mui/material/Tab';
 *
 * <Tabs value={tabValue} onChange={(event, newValue) => setTabValue(newValue)}>
 *   <Tab label="Tab 1" icon={<Icon1 />} />
 *   <Tab label="Tab 2" icon={<Icon2 />} />
 * </Tabs>
 *
 * All additional props and styling are supported as in MUI Tabs.
 */

// Дефолтные стили для Tabs
const getTabsSx = (swapBackground) => (theme) => ({
  minWidth: 0,
  width: '100%',
  minHeight: '0',
  '& .MuiTabs-indicator': { display: 'none' },
  '& .MuiTab-root': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    maxWidth: 'none',
    textTransform: 'none',
    fontWeight: 'medium',
    fontSize: { xs: '0.75rem', sm: '0.875rem' },
    flexGrow: 1,
    borderRadius: '10px',
    minHeight: '0',
    opacity: 1,
    padding: { xs: '6px 12px', sm: '12px 16px' },
    '&.Mui-selected': {
      bgcolor: swapBackground ? theme.palette.background.default : theme.palette.background.paper,
      color: 'text.primary',
    },
    '&:hover': {
      bgcolor: swapBackground ? theme.palette.background.default : theme.palette.background.paper,
      transition: 'background 0.2s',
    },
  },
});

const Tabs = ({ value, onChange, children, sx, swapBackground = false, ...props }) => {
  // Универсальный обработчик onChange
  const handleChange = (event, newValue) => {
    if (typeof onChange === 'function') {
      if (onChange.length === 2) {
        onChange(event, newValue); // MUI-стиль
      } else {
        onChange(newValue); // Старый стиль
      }
    }
  };

  return (
    <MuiTabs
      value={value}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={[getTabsSx(swapBackground), sx]}
      aria-label={props['aria-label'] || 'tabs'}
      {...props}
    >
      {children}
    </MuiTabs>
  );
};

export default Tabs;
